import styled from "styled-components";

export default styled.div`
  position: fixed;
  top: 100px;
  overflow-x: hidden;
  color: #fff;
  padding: 5px 25px;
  border-radius: 4px;
  z-index: 10000;
  font-size: xx-small;
  max-width: 400px;

  .alert-close {
    position: absolute;
    margin: 5px;
    top: 0px;
    right: 0px;
    color: #fff;
    font-weight: bold;
    font-size: x-large;
    cursor: pointer;
  }
`;
